import React from 'react';
import { Button, Panel, Table } from '@/components/Bicester';
import { Cell } from '@/components/Bicester/Table/Cells';
import { useRequest } from 'ahooks';
import { fetchDigtailQList } from '@/services/special';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { ShoppingVillage } from '@/constants';
import useContentHeight from '@/hooks/useContentHeight';
import { API_DIGTAILQ_CONSOLE } from '@/services/APIs';

const SpecialSale = () => {
  const { profile } = useReadyInfo();

  const { data: digtailQListData, loading: digtailQListLoading } = useRequest(() =>
    fetchDigtailQList(profile?.shopping_village)
  );

  return (
    <Panel
      title={`${ShoppingVillage[profile?.shopping_village]}购物村特卖`}
      leftShadow
      style={{
        height: 'calc(100vh - var(--headerHeight) - var(--navBarHeight))',
      }}
      loading={digtailQListLoading}
    >
      <Table
        style={{
          height: useContentHeight({
            withPanelPaddingTop: true,
            withPanelPaddingBottom: true,
            withPanelHeader: true,
          }),
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        pageInfo={{ page: 1, total: digtailQListData?.store_list?.length }}
        data={digtailQListData?.store_list}
        columns={[
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '活动名',
            cell: <Cell dataKey="name" />,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '是否启用',
            cell: <Cell>{(rowData) => (rowData?.is_stopped === 0 ? '是' : '否')}</Cell>,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: ' ',
            cell: (
              <Cell>
                {(rowData) => (
                  <Button
                    style={{ ...(rowData?.is_stopped !== 0 && { color: '#999999' }) }}
                    appearance="link"
                    href={`${API_DIGTAILQ_CONSOLE}?store_id=${rowData?.id}`}
                    target="_blank"
                  >
                    进入控制台
                  </Button>
                )}
              </Cell>
            ),
          },
        ]}
      >
        <Table.Body
          height={useContentHeight({
            withPanelPaddingTop: true,
            withPanelPaddingBottom: true,
            withPanelHeader: true,
          })}
        />
      </Table>
    </Panel>
  );
};

export default SpecialSale;
